const baseURL = process.env.REACT_APP_BACKEND_URL;

export const CONNECTION_ERROR = "Could not Connect try Again"
export const productImageUrl = `${baseURL}/public/uploads/products/`
